import { DOCTYPES } from '@/constants/doctypes'
import { HAS_LIST_VIEW_ONE_PERMISSION_OF } from '@/constants/permissions'
import { createSingleViewRoutes } from '@/routers/routes/createDoctypeRoutes'

const { home: routeDatevMasterDataHome, root: routeDatevMasterDataRoot } = createSingleViewRoutes({
  doctypes: {
    [DOCTYPES.DATEV_SETTINGS]: HAS_LIST_VIEW_ONE_PERMISSION_OF,
  },
  name: 'datev-master-data-home',
  path: 'datev-master-data',
  view: async () =>
    await import('@/components/viewsExternal/settings/accounting/ViewAccountingSettings.vue'),
})

export { routeDatevMasterDataHome, routeDatevMasterDataRoot }
